import BaseResource from './BaseResource';

export default class StoryResource extends BaseResource {
  static urlRoot = '/api/v2/stories';

  id = '';

  title = '';

  storyFormat = '';

  brandProfileId = '';

  mentionableUsersBasicInfo = [];

  availableFields = [];

  pk() {
    return this.id;
  }
}



// WEBPACK FOOTER //
// ./app/javascript/client/resources/StoryResource.js